module.exports = "/_next/static/images/emily-clark@3x-96aa3443f9eb4856cb4a6e124299afe8.png";